import * as React from 'react';
import { cn } from 'fc/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, maxLength, error, ...props }, ref) => {
    const [inputValue, setInputValue] = React.useState<string | undefined>(
      props.value?.toString() || ''
    );

    return (
      <div
        className={cn(
          'flex items-center w-full h-10 rounded-md border px-3 py-2 text-sm bg-background',
          error
            ? 'border-red-500 focus-within:border-red-600 text-red-500'
            : 'border-input focus-within:border-blue-500',
          className
        )}
      >
        <input
          type={type}
          maxLength={maxLength}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            props.onChange?.(e);
          }}
          className="flex-grow w-full bg-transparent focus:outline-none placeholder:text-muted-foreground [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };
